import React from "react";
import { Container, Row, Col, Card, Image, Button } from "react-bootstrap";
import plugInAssemblies from "../Assets/Image/bts.jpg";
import precisionImage from "../Assets/Image/subassemblytrunking.jpg";
import { useNavigate } from "react-router-dom";
import { IoMdArrowRoundBack } from "react-icons/io";
import { Helmet } from "react-helmet";
const BusbartrunkingPlugInAssemblies = () => {
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>Busbar Trunking - Plug In Assemblies | Delta Engineering</title>
        <meta
          name="description"
          content="Plug-in assemblies for busbar trunking systems provide modular, safe, and efficient power tapping. Designed for industrial, commercial, and renewable energy applications with ratings up to 1250A."
        />
        <meta
          name="keywords"
          content="Busbar Trunking Plug In Assemblies, Plug In Busbar System, Modular Busbar Distribution, Busbar Tap Off Box, High Current Plug In Assemblies, IEC Busbar Components, Electrical Power Distribution Assemblies"
        />

        {/* Open Graph / Facebook */}
        <meta
          property="og:title"
          content="Busbar Trunking - Plug In Assemblies"
        />
        <meta
          property="og:description"
          content="High-performance plug-in assemblies engineered for modular busbar trunking systems. Safe, efficient, and customizable for industrial and commercial power distribution."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.yourdomain.com/busbar-trunking-plug-in-assemblies"
        />
        <meta
          property="og:image"
          content="https://www.yourdomain.com/images/busbar-trunking-plug-in-assemblies.jpg"
        />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Busbar Trunking - Plug In Assemblies | Delta Engineering"
        />
        <meta
          name="twitter:description"
          content="Durable, modular plug-in assemblies for busbar trunking systems. Designed for industrial plants, data centers, high-rise buildings, and renewable energy setups."
        />
        <meta
          name="twitter:image"
          content="https://www.yourdomain.com/images/busbar-trunking-plug-in-assemblies.jpg"
        />
      </Helmet>

      <section className="productbanner1 d-flex align-items-center position-relative">
        <div className="overlay-layer"></div>
        <Container className="text-center position-relative z-2">
          <Row className="justify-content-center">
            <Col lg={8} className="hero-content text-center">
              <h2
                className="hero-title"
                data-aos="zoom-in"
                data-aos-delay="300"
              >
               <span className="blue-text">   Busbar Trunking - </span>{" "}
            <span className="white-text">Plug In Assemblies</span>
              </h2>
              <p
                className="hero-subtitle"
                data-aos="zoom-in"
                data-aos-delay="200"
              >
               Engineered sub-assemblies for busbar trunking ensure reliable, compact, and low-maintenance power distribution.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      <div className="py-3 bg-light" style={{ position: "relative" }}>
        <Button onClick={() => navigate("/ourproducts")} className="back-btn">
          <IoMdArrowRoundBack className="back-icon" />
          Back
        </Button>
        <Container>
          <Row className="text-center mb-4">
            <Col>
              <h3 className="fw-bold section-title">
                Plug In Assemblies
                <span className="title-underline"></span>
              </h3>
              <p className="text-muted">
                Designed to provide safe, efficient power connections for
                switchgear, distribution panels, and load centers.
              </p>
            </Col>
          </Row>

          <Row className="align-items-center mb-5">
            <Col md={6} data-aos="fade-up">
              <Image
                src={plugInAssemblies}
                alt="Plug In Assembly"
                fluid
                rounded
                style={{ width: "100%", height: "300px", objectFit: "cover" }}
              />
            </Col>
            <Col md={6} data-aos="fade-up" data-aos-delay="150">
              <h4 className="fw-semibold mb-3">Overview</h4>
              <p className="text-muted">
                Plug-in assemblies are critical for modular busbar trunking
                systems, allowing flexible, safe tapping of power without
                disrupting the main system. With precision-engineered housings
                and connections, our units are built to deliver efficient
                electrical distribution across various load demands.
              </p>
            </Col>
          </Row>

          <Row className="mb-5">
            <Col md={6}>
              <h5 className="fw-semibold">Key Features</h5>
              <ul className="text-muted ps-3">
                <li>Modular and easy-to-install design</li>
                <li>Supports high current ratings with minimal losses</li>
                <li>Customizable number of poles and rating</li>
                <li>Pre-wired options for faster assembly</li>
                <li>Mechanical interlocks for added safety</li>
              </ul>
            </Col>
            <Col md={6}>
              <h5 className="fw-semibold">Technical Specifications</h5>
              <ul className="text-muted ps-3">
                <li>Rated Voltage: Up to 1000V</li>
                <li>Current Capacity: 63A to 1250A</li>
                <li>Enclosure: Steel / Aluminum options</li>
                <li>Protection: IP54 / IP65 (customizable)</li>
                <li>Compliance: Meets IEC/IS standards</li>
              </ul>
            </Col>
          </Row>

          <Row className="mb-5">
            <Col data-aos="fade-up">
              <h4 className="fw-bold text-center mb-3">
                Why Choose Our Plug-In Assemblies?
              </h4>
              <p className="text-center text-muted">
                We ensure durability, modularity, and safety in every unit we
                manufacture. From small-scale setups to large commercial
                installations, our assemblies provide consistent performance and
                minimal downtime.
              </p>
            </Col>
          </Row>

          <h5 className="fw-semibold text-center mb-4">Applications</h5>
          <Row className="mb-5">
            <Col md={{ span: 8, offset: 2 }} data-aos="zoom-in">
              <ul className="text-muted ps-3">
                <li>Commercial and Industrial Electrical Distribution</li>
                <li>Data Centers and Telecom Infrastructure</li>
                <li>Factories, Malls, and High-rise Buildings</li>
                <li>Renewable energy installations</li>
                <li>Power panels, switchboards, and MCCs</li>
              </ul>
            </Col>
          </Row>

          <Row className="align-items-center mt-5">
            <Col md={6} data-aos="zoom-in">
              <Image
                src={precisionImage}
                alt="Precision Assembly"
                fluid
                rounded
                style={{ width: "90%", height: "250px", objectFit: "cover" }}
              />
            </Col>
            <Col md={6} data-aos="zoom-in" data-aos-delay="150">
              <h4 className="fw-semibold mb-3">Precision Assembly in Action</h4>
              <p className="text-muted">
                Our state-of-the-art manufacturing units integrate precision
                equipment with expert craftsmanship to deliver plug-in
                assemblies tailored for robust power distribution. Every
                assembly undergoes rigorous testing to ensure it meets the
                highest standards of quality and performance.
              </p>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default BusbartrunkingPlugInAssemblies;
